var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustSay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 360.86 81.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#outer-glow-1);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    x: -21.81,
    y: -21.08,
    width: 404,
    height: 124,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.78
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.55,42.51v2.3c0,9.68,4.66,14.52,13.99,14.52,4.72,0,8.18-1.06,10.36-3.19,2.48-2.42,3.72-6.55,3.72-12.4V0h6.55v45.52c0,5.9-1.68,10.54-5.05,13.9-3.66,3.6-8.97,5.4-15.94,5.4-8.56,0-14.38-2.75-17.45-8.24-1.71-3.01-2.63-7.7-2.75-14.08h6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.12,63.23v-9.03c-1.07,2.72-3.23,5.08-6.49,7.08-3.68,2.24-7.89,3.37-12.63,3.37-13.34,0-20.02-6.32-20.02-18.95v-28.52h6.55v29.67c0,8.21,4.63,12.31,13.9,12.31,12.46,0,18.69-5.67,18.69-17v-24.97h6.55v46.05h-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.07,30.82h-6.02c-.83-3.6-2.48-6.14-4.96-7.62-2.3-1.3-5.93-1.95-10.89-1.95-8.86,0-13.28,2.63-13.28,7.88,0,2.36,1.09,3.99,3.28,4.87,2.01.89,6.61,1.8,13.81,2.75,7.44,1,12.52,2.33,15.23,3.99,3.13,1.89,4.69,4.99,4.69,9.3,0,4.6-1.86,8.19-5.58,10.76-3.72,2.57-9.15,3.85-16.29,3.85-15.53,0-23.29-5.28-23.29-15.85h6.02c.59,3.84,2.14,6.52,4.65,8.06,2.51,1.54,6.71,2.3,12.62,2.3,10.21,0,15.32-2.92,15.32-8.77,0-2.36-1.15-4.1-3.45-5.22-2.48-1.18-7.2-2.13-14.17-2.83-7.14-.71-12.16-2.02-15.05-3.94-2.89-1.92-4.34-4.92-4.34-8.99s1.62-7.41,4.87-9.83c3.48-2.54,8.47-3.81,14.97-3.81,13.76,0,21.05,5.02,21.87,15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.53,17.18V2.66h6.55v14.52h13.02v4.96h-13.02v30.54c0,2.13.46,3.64,1.37,4.53.91.89,2.64,1.33,5.18,1.33s4.81-.21,6.46-.62v5.57c-2.48.36-4.87.54-7.17.54-4.84,0-8.18-.98-10.01-2.93-1.59-1.66-2.39-4.5-2.39-8.52v-30.44h-10.01v-4.96h10.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.09,30.82h-6.02c-.83-3.6-2.48-6.14-4.96-7.62-2.3-1.3-5.93-1.95-10.89-1.95-8.86,0-13.28,2.63-13.28,7.88,0,2.36,1.09,3.99,3.28,4.87,2.01.89,6.61,1.8,13.81,2.75,7.44,1,12.52,2.33,15.23,3.99,3.13,1.89,4.69,4.99,4.69,9.3,0,4.6-1.86,8.19-5.58,10.76-3.72,2.57-9.15,3.85-16.29,3.85-15.53,0-23.29-5.28-23.29-15.85h6.02c.59,3.84,2.14,6.52,4.65,8.06,2.51,1.54,6.71,2.3,12.62,2.3,10.21,0,15.32-2.92,15.32-8.77,0-2.36-1.15-4.1-3.45-5.22-2.48-1.18-7.2-2.13-14.17-2.83-7.14-.71-12.16-2.02-15.05-3.94-2.89-1.92-4.34-4.92-4.34-8.99s1.62-7.41,4.87-9.83c3.48-2.54,8.47-3.81,14.97-3.81,13.76,0,21.05,5.02,21.87,15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.7,31.35h-6.02c.53-5.14,2.33-8.94,5.4-11.42,3.54-2.77,9.06-4.16,16.56-4.16s12.93,1.15,16.29,3.45c3.19,2.24,4.78,5.64,4.78,10.18v24.09c0,3.42,1.21,5.14,3.63,5.14h3.45v4.28c-2.36.46-4.19.68-5.49.68-2.95,0-4.96-.91-6.02-2.75-.65-1.12-1-2.92-1.06-5.4h-.18c-4.13,6.14-11.31,9.21-21.52,9.21-4.66,0-8.62-1-11.87-3.01-4.02-2.48-6.02-6.08-6.02-10.8,0-5.55,2.57-9.44,7.7-11.69,3.25-1.48,8.37-2.4,15.36-2.79,7-.38,11.41-.91,13.24-1.59,1.83-.68,2.75-2.17,2.75-4.47,0-3.31-1.18-5.64-3.54-7-2.36-1.36-6.26-2.04-11.69-2.04s-9.14.78-11.65,2.35c-2.51,1.56-3.88,4.15-4.12,7.75ZM298.7,45.43v-7c-1.36.89-3.48,1.54-6.38,1.95-1.95.3-6.64.8-14.08,1.51-8.03.77-12.04,3.6-12.04,8.5,0,6.2,4.43,9.3,13.28,9.3,4.9,0,9.21-1.18,12.93-3.54,4.19-2.71,6.29-6.29,6.29-10.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336.42,55.52l17.36-38.34h7.08l-24.97,54.64c-1.65,3.66-3.41,6.12-5.27,7.39-1.86,1.27-4.59,1.9-8.19,1.9-2.89,0-4.99-.06-6.29-.17v-5.32h4.69c2.42,0,4.28-.38,5.58-1.15,1.3-.77,2.48-2.27,3.54-4.52l3.01-6.38-22.4-46.4h7.08l18.77,38.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustSay);
export default __webpack_public_path__ + "static/media/just-say.c5f91b0f006bfed106c5e829f990e5fe.svg";
export { ForwardRef as ReactComponent };